import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useFonts } from '@use-expo/font';

import { useDimensions } from '../../../context/DimensionsContext';
import { white, green, blue } from '../../../constants/brand';
import { ShortLogo } from '../../common/ShortLogo';
import { TouchableOpacity } from '../../common/TouchableOpacity';
import { MenuItem } from './MenuItem';

interface Props {}

export const DeckMenu: React.FC<Props> = React.memo(() => {
  const { width, height } = useDimensions();

  const styles = StyleSheet.create({
    quote: {
      fontFamily: 'Panama-Regular',
      color: blue,
      textTransform: 'uppercase',
      fontSize: 36,
      letterSpacing: 1.3,
      marginVertical: 15,
    },
    navItem: {
      fontFamily: 'GTAmerica-CompressedRegular',
      fontSize: 24,
      letterSpacing: 1.3,
      color: green,
      marginVertical: 5,
    },
  });

  const [fontsLoaded] = useFonts({
    'GTAmerica-CompressedRegular': require('../../../../assets/fonts/GTAmerica-CompressedRegular.otf'),
    'Panama-Regular': require('../../../../assets/fonts/Panama-Regular.otf'),
  });

  if (!fontsLoaded) return null;

  return (
    <View
      style={{
        position: 'absolute',
        marginTop: 50,
        right: 0,
        width: '100vw',
        height: 450,
        backgroundColor: white,
        zIndex: 10,
        borderWidth: 1,
        borderColor: green,
      }}
    >
      <View
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          position: 'absolute',
          left: '19.5%',
          marginTop: 10,
        }}
      >
        <MenuItem title="Mission" path="/mission" />
        <MenuItem title="Opportunity" path="/opportunity" />
        <MenuItem title="Market" path="/market" />
        <MenuItem title="Product" path="/product" />
        <MenuItem title="Customers" path="/customers" />
        <MenuItem title="Go to Market" path="/gotomarket" />
        <MenuItem title="Team" path="/team" />
        <MenuItem title="Progress" path="/progress" />
        <MenuItem title="Full Deck" path="/deck" />
      </View>
      <View style={{ position: 'absolute', right: 180, marginTop: 80 }}>
        <View style={{ alignItems: 'center' }}>
          <Text style={styles.quote}>BE BRAVE ENOUGH TO BE TERRIBLE.</Text>
        </View>
        <View style={{ position: 'absolute', right: 0, marginTop: 120 }}>
          <ShortLogo />
        </View>
      </View>
    </View>
  );
});
